import MySubscription from '@/views/subscription/views/MySubscription.vue';
import SubscriptionPackages from '@/views/subscription/views/SubscriptionPackages.vue';
import SubscriptionPackagesVersion2 from '@/views/subscription/views/SubscriptionPackagesVersion2.vue';

export default [
  {
    path: '/profile/my_subscription/',
    component: MySubscription,
    meta: { 
      //requiresPermission: 'my_subscription', 
      //requiresSubscription: 'my_subscription',
      featureName: 'My Subscription' 
    } 
    //component: () => import('@/views/subscription/views/SubscriptionRequired.vue')
  },
  {
    path: '/subscription/subscription_packages/',
    component: SubscriptionPackages,
    //component: () => import('@/views/subscription/views/SubscriptionPackages.vue'),
    meta: { 
      requiresPermission: 'packages.view', 
      requiresSubscription: 'packages.view',
      featureName: 'Subscription Packages' 
    } 
    //meta: { requiresPermission: 'packages.view'} 
  },
  {
    path: '/subscription/subscription_packages_v2/',
    component: SubscriptionPackagesVersion2,
    //component: () => import('@/views/subscription/views/SubscriptionPackages.vue'),
    meta: { 
      requiresPermission: 'packages.view', 
      requiresSubscription: 'packages.view',
      featureName: 'Subscription Packages Version2' 
    } 
    //meta: { requiresPermission: 'packages.view'} 
  }
];
